import * as React from "react"
import { storyblokEditable } from "gatsby-source-storyblok"
import TourCard from "./tourCard"

const LuxuryTours = ({ blok }) => {

  return (
    <div id="tours" className="pt-10" {...storyblokEditable(blok)}>
      <div className="container max-w-[700px] mx-auto py-10 text-center">
        <h2 className="text-3xl font-bold">{blok.title}</h2>
        <div className="py-5">{blok.description}</div>
      </div>

      <div className="container mx-auto pb-10">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-10">
          {
            blok.tours?.map((tour, i) => {
              return (
                <div key={i} className="min-h-[500px] border rounded-lg hover:scale-105 hover:shadow-md transition">
                  <TourCard blok={tour} />
                </div>
              )
            })
          }
        </div>
      </div>
    </div>)
}

export default LuxuryTours
